import { jsx as _jsx } from "react/jsx-runtime";
export function Spinner({ size = 14, light }) {
    return _jsx("span", { "aria-label": "Loading", style: { width: size, height: size, border: `2px solid ${light ? 'rgba(255,255,255,.35)' : 'var(--border-strong)'}`, borderTopColor: light ? '#fff' : 'var(--text)', borderRadius: '50%', display: 'inline-block', animation: 'tl-spin .8s linear infinite' } });
}
//# sourceMappingURL=Spinner.js.map